<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<div *ngIf="!(loadingUsers$ | async)">
        <span class="users-data-loaded"></span>
</div>

<div class="main-content manage-content" appLifecycleTracker trackerName="organizations" trackerEvents="['click']" *ngIf="partnersById$ | async as partnersById">
    <div class="manage-header">
      <div>
        <button mat-flat-button id="buttonAddUser" [disabled]="(loadingUsers$ | async) || managing_user?.subscriptions_count === 0" color="primary"
                (click)="addOrganization()">{{fAdd}}</button>
      </div>
      <div>
        <button mat-flat-button id="buttonAddSubscription" [disabled]="disable_add_subscription_btn" color="primary"
                (click)="addSubscriptionButton()">{{fAddSubscription}}</button>
      </div>
      <div>
        <button mat-flat-button id="buttonReactivateOrgs" [disabled]="disable_reactivate_btn" color="primary"
                (click)="reactivateOrganization()">{{fReactivate}}</button>
      </div>
      <div>
        <button mat-flat-button id="buttonDeactivateOrgs" [disabled]="disable_deactivate_btn" color="primary"
                (click)="deactivateOrganization()">{{fDeactivate}}</button>
      </div>
      <div>
        <button mat-flat-button id="buttonPriorityEngageOrgs" [disabled]="disable_priority_lock_btn" color="primary"
                (click)="engagePriorityLockSelectedOrganizations()">{{'priority_lock.lock_button' | translate}}</button>
      </div>
      <div>
        <button mat-flat-button id="buttonPriorityReleaseOrgs" [disabled]="disable_priority_lock_release_btn" color="primary"
                (click)="releasePriorityLockSelectedOrganizations()">{{'priority_lock.release_button' | translate}}</button>
      </div>
    </div>

    <div class="dashboard-component">
      <mat-card appearance="raised" style="">
        <mat-card-header>
          <mat-card-title>
            {{'APP_ORGANIZATIONS' | translate}}
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="counts-text">
            {{ 'SHOWING_OF' | translate : {subtotal: organizationsCount, total: allOrgsCount} }}
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card appearance="raised" style="">
        <mat-card-header>
          <mat-card-title>
            {{'organizations.sub.subscriptions' | translate}}
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="counts-text">
            {{ 'SHOWING_OF' | translate : {subtotal: subscriptionCount, total: allSubsCount} }}
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card appearance="raised" style="">
        <mat-card-header>
          <mat-card-title>
            {{'APP_LICENSES' | translate}}
          </mat-card-title>
        </mat-card-header>
        <div style="text-align: center" *ngIf="!!totalLicenses">
          <span>{{'ADO_AVAILABLE' | translate}}: {{ totalLicenses }}</span>
        </div>
        <span style="display: flex; flex-direction: column;">
          <table aria-describedby="Allocated and used license information">
            <tr>
              <td>&nbsp;</td>
              <th scope="col" style="text-align: right">{{'FILTERED' | translate}}</th>
              <th scope="col" style="text-align: right">{{'ALL' | translate}}</th>
            </tr>
            <tr>
              <th scope="row" style="text-align: left">{{'ALLOCATED' | translate}}</th>
              <td style="text-align: right">{{ allocatedLicensesDisplay }}</td>
              <td style="text-align: right">{{ allAllocatedLicensesDisplay }}</td>
            </tr>
            <tr>
              <th scope="row" style="text-align: left">{{'L_HUSED' | translate}}</th>
              <td style="text-align: right">{{ usedLicenses }}</td>
              <td style="text-align: right">{{ allUsedLicenses }}</td>
            </tr>
          </table>
        </span>
      </mat-card>

    </div>

    <div class="table-wrapper">
      <span class="search">
          <button mat-icon-button aria-label="search subscriptions" (click)="searchOrganizations()">
            <span class="mdi mdi-magnify"></span>
          </button>
          <mat-form-field class="search-form-field" appearance="outline">
            <mat-label>{{fTableSearch}}</mat-label>
            <input id="organizationSearch" matInput type="text" placeholder="{{fTableHolder}}" [(ngModel)]="searchTerm"
                   (keydown.enter)="searchOrganizations()" maxlength="255"/>
            <button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
              <span class="mdi mdi-close" aria-hidden="true"></span>
            </button>
          </mat-form-field>
      </span>
      <span class="filter">
        <mat-checkbox id="show-active-orgs" [(ngModel)]="showOnlyActive" (change)="onFilterInactive()">{{'organizations.show-active' | translate}}</mat-checkbox>
        <mat-form-field appearance="outline">
          <mat-label>Filter Subscriptions by</mat-label>
          <mat-select class="" [value]="expirationFilter"
                  aria-label="Select Expiration Filter"
                  [disableOptionCentering]="true" (selectionChange)="onExpirationSelectChanged($event.value)">
              <mat-option [value]="ExpirationFilterType.ALL_SUBSCRIPTIONS">{{'filter.subscriptions.show-all' | translate}}</mat-option>
              <mat-option [value]="ExpirationFilterType.LESS_THAN_1_MONTH">{{'filter.subscriptions.one-month' | translate}}</mat-option>
              <mat-option [value]="ExpirationFilterType.LESS_THAN_3_MONTH">{{'filter.subscriptions.three-month' | translate}}</mat-option>
              <mat-option [value]="ExpirationFilterType.LESS_THAN_6_MONTH">{{'filter.subscriptions.six-month' | translate}}</mat-option>
          </mat-select>
        </mat-form-field>
      </span>
    </div>

    <div class="scroll-viewport mat-elevation-z0">
        <table mat-table *ngIf="!(loadingUsers$ | async); else skeletonLoaderForSubs"
               [dataSource]="matTableUserDataSource" matSort aria-describedby="List of organizations">

          <ng-container matColumnDef="checkbox">
            <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header></th>
            <td mat-cell *matCellDef="let user" class="clickable">
              <mat-checkbox [checked]="isChecked(user)" (change)="onCheckChanged($event, user)"
                            attr.mat-checkbox-id="{{user.email}}"
                            color="primary" aria-label="Select {{user.company || user.email}}"></mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="priority_lock_engaged">s
            <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header></th>
            <td mat-cell id="priority_lock_engaged" *matCellDef="let user" >
              <span *ngIf="user?.priority_lock_engaged" attr.aria-label="{{'priority_lock.icon_label' | translate}}"
                                                     matTooltip="{{'priority_lock.icon_label' | translate}}"
                                                     class="mdi mdi-lock"></span>
          </ng-container>

          <ng-container matColumnDef="company">
            <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{fOrg}}</th>
            <td mat-cell id="company_name" *matCellDef="let user" class="clickable" (click)="editOrg(user)" role="link"
                tabindex="0" (keyup.enter)="editOrg(user)"
                attr.aria-label="Edit {{user.company || user.email}}."> {{user.company || '-'}} </td>
          </ng-container>

          <ng-container matColumnDef="email">
            <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{fEmail}}</th>
            <td mat-cell id="company_email" *matCellDef="let user" class="clickable" (click)="editOrg(user)"> {{user.contact_email}} </td>
          </ng-container>

          <ng-container matColumnDef="username">
            <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{fUser}}</th>
            <td mat-cell *matCellDef="let user"> {{user.username}} </td>
          </ng-container>

          <ng-container matColumnDef="fname">
            <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header> {{fFName}} </th>
            <td mat-cell *matCellDef="let user" class="clickable" (click)="editOrg(user)"> {{user.fname}} </td>
          </ng-container>

          <ng-container matColumnDef="lname">
            <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header> {{fLName}} </th>
            <td mat-cell *matCellDef="let user" class="clickable" (click)="editOrg(user)"> {{user.lname}} </td>
          </ng-container>

          <ng-container matColumnDef="partner">
            <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{'PARTNER' | translate}}</th>
            <td mat-cell *matCellDef="let user" class="subscription-line">{{user.partnerId != undefined ? partnersById[user.partnerId].name : fAdoSysDefault}}</td>
          </ng-container>

          <ng-container matColumnDef="subscription_old">
            <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header> {{fSub}} </th>
            <td mat-cell *matCellDef="let user"> {{user.business_edition ? fD3EPremium : fD3EPersonal}} </td>
          </ng-container>

          <ng-container matColumnDef="subscription">
            <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header> {{fSub}} </th>
            <td mat-cell *matCellDef="let user">
              <span *ngFor="let sub_detail of user.subscriptions; let i = index">
                <span *ngIf="i === 0" matTooltip="{{sub_detail.subscription_id}}" class="subscription-line">
                  {{getSubscriptionProductTierName(sub_detail.tier)}}</span>
                <span *ngIf="i > 0" matTooltip="{{sub_detail.subscription_id}}" class="subscription-line">
                  <br/>{{getSubscriptionProductTierName(sub_detail.tier)}}</span>
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="active">
            <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header> {{fStatus}} </th>
            <td mat-cell *matCellDef="let user">
              <div *ngIf="user.active">
                <span *ngFor="let sub_detail of user.subscriptions; let i = index">
                  <br *ngIf="i > 0"/>
                  <span *ngIf="sub_detail.expired">{{ "EXPIRED" | translate}}</span>
                  <span *ngIf="sub_detail.type === subtype.LICENSE_TYPE_TRIAL">
                      {{"organizations.sub.type.trial" | translate}}
                  </span>
                  <span *ngIf="sub_detail.type === subtype.LICENSE_TYPE_FREE">
                      {{"organizations.sub.type.free" | translate}}
                  </span>
                  <span *ngIf="!sub_detail.expired && sub_detail.type === subtype.LICENSE_TYPE_TIME_LIMITED">
                      {{"ACTIVE" | translate}}
                  </span>
                  <span *ngIf="sub_detail.type === subtype.LICENSE_TYPE_PERPETUAL">
                      {{"organizations.sub.type.perpetual" | translate}}
                  </span>
                </span>
              </div>
              <div *ngIf="!user.active">
                <span>{{fInactive}}</span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="available">
            <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header style="direction: rtl">{{'TOTAL_LICENSES_TEXT' | translate}}</th>
            <td mat-cell *matCellDef="let user">
              <span *ngFor="let sub_detail of user.subscriptions; let i = index">
                <span *ngIf="i > 0">
                  <br/>
                </span>
                  {{getTotalSubscriptionLicenses(sub_detail)}}
                <span [ngClass]="{'mdi': true,
                                  'mdi-pencil': true,
                                  'clickable': true,
                                  'invisible': sub_detail.payment_source >= PaymentSource.STRIPE || sub_detail.type == this.subtype.LICENSE_TYPE_FREE }"
                      tabindex="0"
                      role="button"
                      attr.aria-label="Edit license count for {{user.company || user.email}}"
                      [attr.aria-hidden]="false"
                      (click)="editSubLicenseCount(sub_detail)"
                      (keyup.enter)="editSubLicenseCount(sub_detail)"></span>
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="allocated">
            <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header style="direction: rtl"> {{fAllocated}} </th>
            <td mat-cell *matCellDef="let user">
              <span *ngFor="let sub_detail of user.subscriptions; let i = index">
                <span *ngIf="i === 0">
                  {{getAllocatedSubscriptionLicenses(sub_detail)}}
                </span>
                <span *ngIf="i > 0">
                  <br/>
                    {{getAllocatedSubscriptionLicenses(sub_detail)}}
                </span>
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="used">
            <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header style="direction: rtl"> {{fUsed}} </th>
            <td mat-cell *matCellDef="let user">
              <span *ngFor="let sub_detail of user.subscriptions; let i = index">
                <span *ngIf="i === 0">
                  {{getUsedSubscriptionLicenses(sub_detail)}}
                </span>
                <span *ngIf="i > 0">
                  <br/>
                    {{getUsedSubscriptionLicenses(sub_detail)}}
                </span>
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="pba_used">
            <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header style="direction: rtl"> PBA Used </th>
            <td mat-cell *matCellDef="let user">
              <span *ngFor="let sub_detail of user.subscriptions; let i = index">
                <span *ngIf="i === 0">
                  {{getPbaUsedLicenses(sub_detail)}}
                </span>
                <span *ngIf="i > 0">
                  <br/>
                    {{getPbaUsedLicenses(sub_detail)}}
                </span>
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="fde_used">
            <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header style="direction: rtl"> FDE Used </th>
            <td mat-cell *matCellDef="let user">
              <span *ngFor="let sub_detail of user.subscriptions; let i = index">
                <span *ngIf="i === 0">
                  {{getFdeUsedLicenses(sub_detail)}}
                </span>
                <span *ngIf="i > 0">
                  <br/>
                    {{getFdeUsedLicenses(sub_detail)}}
                </span>
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="expiration">
            <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{fExpires}}</th>
            <td mat-cell *matCellDef="let user">
              <span *ngFor="let sub_detail of user.subscriptions; let i = index">
                <div class="date-column-cell">
                  <div id="subscriptionExpiration_{{i}}" class="date-column-date" style="padding-top: 4px">
                    {{ getSubscriptionExpiration(sub_detail) }}
                  </div>
                  <div class="date-column-icon">
                    <span id="editExpirationDate" class="mdi mdi-calendar clickable" [ngClass]="{'invisible': sub_detail.payment_source >= PaymentSource.STRIPE}"
                          tabindex="0"
                          role="button"
                          attr.aria-label="Edit expiration for {{user.company || user.email}}" [attr.aria-hidden]="false"
                          (click)="editSubExpDate(sub_detail)"
                          (keyup.enter)="editSubExpDate(sub_detail)"></span>
                  </div>
                </div>
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="maint_exp">
              <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{'MAINT_EXPIRES' | translate}}</th>
              <td mat-cell *matCellDef="let user">
                  <span *ngFor="let sub_detail of user.subscriptions">
                    <div class="date-column-cell">
                        <div class="date-column-date" style="padding-top: 4px">
                            {{ sub_detail.maint_exp_timestamp | date }}
                        </div>
                    </div>
                  </span>
              </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="usersColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: usersColumns;"></tr>
        </table>
        <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"></mat-paginator>
      </div>

      <ng-template #skeletonLoaderForSubs>
        <ngx-skeleton-loader
          count="5"
          appearance="line"
          [theme]="{
            height: '45px',
            width: '97%',
            margin: '15px 0 -5px 15px'
        }">
        </ngx-skeleton-loader>
      </ng-template>

</div>

